module.exports = __webpack_public_path__ + "768508b67b8d474140e356c9b6b47d24.png";